export default __webpack_public_path__ + "static/media/16_9_Master Graphic My Scania 1600x716.69124c55.png";